import { Link } from 'react-router-dom'
import { useMaharajTiers } from '../booking/useMaharajTiers'

const TIER_ICONS = {
  zap: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" />
    </svg>
  ),
  star: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="m12 2 3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2Z" />
    </svg>
  ),
  thumb: (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M7 22V11m0 0-3 0a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3m0-10 5.5-7a2 2 0 0 1 3.5 1.4V9h4a2 2 0 0 1 2 2.24l-1.14 8A2 2 0 0 1 18 21H7" />
    </svg>
  ),
}

export default function MaharajPriorityTiersSection() {
  const tiers = useMaharajTiers()
  return (
    <div className="info-card p-6 sm:p-8 space-y-5">
      <div>
        <h2 className="text-xl font-cinzel text-[#1C140A]">Priority audience tiers</h2>
        <p className="mt-1.5 text-xs text-[#8B7355] max-w-2xl">
          A concierge model reserved only for Raju Maharaj Ji — your fee is set by how soon you wish to be seen.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        {tiers.map((tier) => (
          <article
            key={tier.key}
            className={`relative overflow-hidden rounded-2xl border p-5 transition-colors ${
              tier.recommended ? 'border-secondary/50' : 'border-[#D7C29A]/25 hover:border-secondary/40'
            }`}
          >
            {tier.recommended && <span className="feat-ribbon">Recommended</span>}
            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-[#C8922A]" style={{ background: 'rgba(200,146,42,.08)' }}>
              {TIER_ICONS[tier.icon]}
            </div>
            <h3 className="mt-4 text-sm font-bold text-[#1C140A]">{tier.label}</h3>
            <p className="mt-1 text-[11px] text-[#8B7355]">
              Seen within {tier.minDays}–{tier.maxDays} day{tier.maxDays === 1 ? '' : 's'}
            </p>
            <p className="mt-3 text-2xl font-cinzel font-bold text-[#C8922A]">₹{tier.price.toLocaleString('en-IN')}</p>
          </article>
        ))}
      </div>

      <Link
        to="/book-maharaj-ji"
        className="hero-btn-primary premium-shine inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] whitespace-nowrap"
      >
        Check Availability
      </Link>
    </div>
  )
}
